import {
  Avatar,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Grid,
  Icon,
  IconButton,
  Image,
  Text,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { LanguageSelect } from '@shared/components';
import { ArrowLeft, ShoppingCart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useGetUserInfo } from '../hooks';

import { Steps } from './Steps';

interface IHeaderProps {
  rootEntity: string;
  currentStep: number;
  customTitle?: string;
  cart?: React.ReactNode;
}

export const Header = ({
  rootEntity,
  currentStep,
  customTitle,
  cart,
}: IHeaderProps) => {
  const { t } = useTranslation([rootEntity, 'common']);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: userInfo } = useGetUserInfo();

  const isMobile = useBreakpointValue({ base: true, lg: false });

  if (isMobile)
    return (
      <Flex
        bg="business.900"
        px={6}
        py={4}
        justifyContent="space-between"
        gap={4}
      >
        <Flex alignItems="center" gap={4}>
          <Image src="/images/Icon.png" alt="logo" w={6} />
          <Text color="white" fontSize="lg" fontWeight="semibold">
            {customTitle || t(`${rootEntity}:title`)}
          </Text>
        </Flex>
        <IconButton
          icon={<Icon as={ShoppingCart} fontSize={18} color="white" />}
          size="sm"
          variant="ghost"
          aria-label="Carrinho"
          onClick={onOpen}
        />
        {isOpen && (
          <Drawer
            placement="right"
            size="full"
            onClose={onClose}
            isOpen={isOpen}
          >
            <DrawerOverlay />
            <DrawerContent display="flex" flexDir="column" alignItems="center">
              <Flex
                bg="business.900"
                px={6}
                py={4}
                justifyContent="space-between"
                gap={4}
                w="full"
              >
                <Flex alignItems="center" gap={4} w="full">
                  <Image src="/images/Icon.png" alt="logo" w={6} />
                  <Text color="white" fontSize="lg" fontWeight="semibold">
                    {t('common:myProducts')}
                  </Text>
                </Flex>
                <IconButton
                  icon={<Icon as={ArrowLeft} fontSize={18} color="white" />}
                  size="sm"
                  variant="ghost"
                  color="brand"
                  aria-label="Carrinho"
                  onClick={onClose}
                />
              </Flex>
              <Flex p={4} h="full" w="full">
                {cart}
              </Flex>
            </DrawerContent>
          </Drawer>
        )}
      </Flex>
    );

  return (
    <Grid pb={5} gap={5} alignItems="center" templateColumns="1fr 420px">
      <Steps currentStep={currentStep} />

      <Flex justifySelf="flex-end" gap={2}>
        <Flex
          alignItems="center"
          gap={2}
          p={2}
          border="1px solid"
          borderColor="gray.200"
          borderRadius="lg"
        >
          <Avatar
            size="xs"
            src={userInfo?.avatarUrl}
            name={userInfo?.displayName}
          />

          <Text fontSize="sm" fontWeight="semibold">
            {userInfo?.displayName}
          </Text>
        </Flex>
        <LanguageSelect />
      </Flex>
    </Grid>
  );
};
